import { inject, Injectable, DOCUMENT } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScreenResolutionService {
	private readonly document = inject(DOCUMENT);

	get isGreaterThanOrEqualToLg(): boolean {
		const width = this.document?.defaultView?.innerWidth ?? 0;
		return width >= 1024;
	}

	get isLessThanLg(): boolean {
		const width = this.document?.defaultView?.innerWidth ?? 0;
		return width < 1024;
	}

	get isMobile(): boolean {
		const width = this.document?.defaultView?.innerWidth ?? 0;
		return width < 768;
	}
}
